import React from "react";
import * as Helper from "../Helper";

interface Props {
  settings: any;
  setSettings: any;
}
const PreContingentChangeForm = (props: Props) => {
  const { settings, setSettings } = props;
  const resourceTypeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const clone: Helper.Settings = {};
    Object.assign(clone, settings);
    clone.rentalType = e.target.value;
    clone.usedForm = e.target.value;
    clone.usedContingentForm = e.target.value;
    clone.usedPriceForm = e.target.value;
    clone.preSelectContingentForm = false;
    clone.initialized = true;
    setSettings(clone);
  };

  return (
    <>
      <div className="inb-form-group column medium-4 small-6" key={"resourceTypeSelect"}>
        <select onChange={resourceTypeSelect}>
          {Object.keys(Helper.acceptedResourceTypes).map((resourceType: string) => {
            return (
              // @ts-ignore
              <option
                key={resourceType}
                value={Helper.acceptedResourceTypes[resourceType]}
              ></option>
            );
          })}
        </select>
      </div>
    </>
  );
};
export default PreContingentChangeForm;
